/* eslint-disable indent */
/* ====================================================================
   IMPORTS
   ==================================================================== */

/**
 * Dependency imports
 */

import createBehaviour from '../helpers/_createBehaviour';

/**
 * Behaviour imports
 */

/* ====================================================================
   BEHAVIOURS —> FADE ACCORDION
   ==================================================================== */

const extractText = createBehaviour(
  /**
   * Register a name for the behaviour
   */

  'extractText',
  {
    /**
     * All behaviour functions should be defined here and will be
     * accessible through 'this'
     *
     * Event listeners, intervals etc. will need to be registered
     * using the below lifecycle events
     */

    logInit() {
      console.log(`${this.name}: Initialised`);
    },
    logEnabled() {
      console.log(`${this.name}: Enabled`);
    },
    logDestroyed() {
      console.log(`${this.name}: Destroyed`);
    },
  },
  {
    init() {
      /**
       * The behaviour has been initialised; event listeners,
       * variables etc. should be registered here
       *
       * All functions, variables etc. are accessible through `this`
       */
      /**
       * Expose the behaviour object for debugging
       */
      console.log(`${this.name}:`, this);
      this.description = this.getChild('origin');

      this.extract = function (el, prefix, suffix) {
        let s = el;
        let i = s.indexOf(prefix);
        if (i >= 0) {
          s = s.substring(i + prefix.length);
        } else {
          return '';
        }
        if (suffix) {
          i = s.indexOf(suffix);
          if (i >= 0) {
            s = s.substring(0, i);
          } else {
            return '';
          }
        }
        return s;
      };

      const self = this;

      this.extractShortcode = function (shortcode) {
        const extracted = self.extract(self.description.innerHTML, `<p>[${shortcode}]</p>`, `<p>[/${shortcode}]</p>`);

        console.log('extracted');

        if (extracted) {
          const cloneOuter = this.getChild(`${shortcode}`);

          const cloneArea = cloneOuter.querySelector('[data-extractText-output]');

          console.log(cloneArea);

          if (cloneArea) {
            cloneArea.innerHTML = extracted;
            cloneOuter.classList.add('is-extracted');
          } else {
            return extracted;
          }
        }
      };
    },
    enabled() {
      this.extractShortcode('description');
      this.extractShortcode('key_benefits');
      this.extractShortcode('nutritional_information');
      this.extractShortcode('storage_conditions');
      this.extractShortcode('packaging');
      this.extractShortcode('ingredients');
      this.extractShortcode('feeding_recommendations');
      this.extractShortcode('analytical_constituents');
      this.extractShortcode('fediaf');
    },
  },
);

export default extractText;
